export default {
  'menu.welcome': 'Chào mừng',
  'menu.more-blocks': 'Thêm Block',
  'menu.home': 'Trang chủ',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Trang con',
  'menu.login': 'Đăng nhập',
  'menu.register': 'Đăng ký',
  'menu.register-result': 'Kết quả đăng ký',
  'menu.dashboard': 'Tổng quan',
  'menu.dashboard.analysis': 'Phân tích',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.users': 'Quản lý User',
  'menu.users.users': 'Người dùng',
  'menu.users.roles': 'Vai trò',
  'menu.users.PartnerCredentials': 'Partner Credentials',
  'menu.Organization': 'Quản lý Merchant',
  'menu.Organization.Branches': 'Chi nhánh',
  'menu.Organization.Merchants': 'Merchant',
  'menu.Organization.Products': 'Sản phẩm',
  'menu.ProductLibrary': 'Thư viện sản phẩm',
  'menu.Organization.Terminals': 'Thiết bị POS',
  'menu.Organization.Banks': 'Ngân hàng',
  'menu.Organization.Transactions': 'Giao dịch',
  'menu.Organization.EInvoices': 'Hóa đơn',
  'menu.Organization.Batches': 'Batches',
  'menu.Report': 'Báo cáo',
  'menu.Report.RevenueSharing': 'Chia sẻ doanh thu',
  'menu.Loyalty': 'Loyalty',
  'menu.Loyalty.Customers': 'Khách hàng',
  'menu.Loyalty.Rewards': 'Điểm thưởng',
  'menu.Loyalty.History': 'Lịch sử điểm',
  'menu.Loyalty.Policy': 'Policy',
  'menu.Loyalty.Cards': 'Thẻ',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Tài khoản',
  'menu.account.center': 'Thông tin tài khoản',
  'menu.account.settings': 'Cài đặt tài khoản',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Đăng xuất',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.ProductLibrary.Catalog': 'Danh mục sản phẩm',
  'menu.ProductLibrary.EInvoices': 'Hóa đơn điện tử',
};
